<template>
  <div class="service-change-items" :class="{ 'is-highlighted': highlighted }">
    <p class="mb-2" :class="{ 'is-removal': isRemoval }">
      {{
        service.display_name ||
          (currentLanguage !== "pl"
            ? service.gmb_service_type.display_name_en
            : service.gmb_service_type.display_name)
      }}
    </p>
    <div
      class="service-change-items__data"
      v-if="service.price && service.currency_code"
    >
      <span class="service-change-items__label"
        >{{ $t("message.facilityDetails.services.price") }}:</span
      >
      <div :class="{ 'is-removal': isRemoval }">
        {{ service.price }}{{ service.currency_code }}
      </div>
    </div>
    <div class="service-change-items__data" v-if="service.description">
      <span class="service-change-items__label"
        >{{ $t("message.facilityDetails.services.serviceDescription") }}:</span
      >

      <div :class="{ 'is-removal': isRemoval }">
        {{ service.description }}
      </div>
    </div>
  </div>
</template>

<script>
import { EXTERNAL_CHANGES_TYPE } from "@/enums/external-changes";

export default {
  name: "GmbServiceChangeItem",
  props: {
    service: {
      type: Object
    },
    changeType: {
      type: Number,
      validate: value => Object.values(EXTERNAL_CHANGES_TYPE).includes(value)
    },
    highlighted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
    isRemoval() {
      return this.changeType === EXTERNAL_CHANGES_TYPE.REMOVAL;
    }
  }
};
</script>

<style lang="scss" scoped>
.service-change-items {
  display: flex;
  flex-direction: column;

  &__label {
    @include font-size(12px);
  }

  &.is-highlighted {
    font-weight: bold;
  }

  &__data {
    display: flex;
    flex-direction: column;
  }
}

p {
  line-height: 24px;
  margin-bottom: 0;
  position: relative;
}

.is-removal {
  align-self: flex-start;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    top: 50%;
    background-color: #000;
  }
}
</style>
